import React from 'react';
import dynamic from 'next/dynamic';
import classes from './HeroSignUpForm.module.scss';
import LocalisedSvg from 'components/atoms/LocalisedSvg/LocalisedSvg';
import HeroEntryForm from 'components/organisms/HeroEntryForm/HeroEntryForm';

const OinqSuccess = dynamic(() => import('components/assets/oinq/oinq_success_shadow.svg'));
const OinqSuccessUsa = dynamic(() => import('components/assets/oinq/oinq_success_shadow_usa.svg'));
const OinqSuccessAus = dynamic(() => import('components/assets/oinq/oinq_success_shadow_aus.svg'));
const OinqSuccessCan = dynamic(() => import('components/assets/oinq/oinq_success_shadow_can.svg'));
const OinqSuccessFr = dynamic(() => import('components/assets/oinq/oinq_success_shadow_fr.svg'));
const OinqSuccessDe = dynamic(() => import('components/assets/oinq/oinq_success_shadow_de.svg'));

export interface Props {}

const HeroSignUpForm: React.FC<Props> = () => {
  return (
    <div className={classes.root}>
      <HeroEntryForm />
      <LocalisedSvg
        localisedSvgs={{
          global: OinqSuccess,
          'en-us': OinqSuccessUsa,
          'en-au': OinqSuccessAus,
          'en-ca': OinqSuccessCan,
          'fr-fr': OinqSuccessFr,
          'de-de': OinqSuccessDe,
        }}
        className={classes.welcomeOinq}
      />
    </div>
  );
};

export default HeroSignUpForm;
